<template>
    <div class="card">
        <div class="card-header">
            个人基本信息管理
        </div>
        <table class="table table-bordered mb-0">
            <tbody>
            <tr>
                <th class="text-center align-middle" style="width: 15%">姓名</th>
                <td class="text-left align-middle" style="width: 28%">{{personBasicInfo.personName}}</td>
                <th class="text-center align-middle" style="width: 15%">身份证号码</th>
                <td class="text-left align-middle" style="width: 28%">{{personBasicInfo.cardId}}</td>
                <td class="text-center align-middle" rowspan="5">
                    <img :src="displayPictureUrl" alt="Picture" style="width: 90%; height: auto">
                </td>
            </tr>
            <tr>
                <th class="text-center align-middle" style="width: 15%">性别</th>
                <td class="text-left align-middle" style="width: 28%">{{personBasicInfo.genderName}}</td>
                <th class="text-center align-middle" style="width: 15%">出生日期</th>
                <td class="text-left align-middle" style="width: 28%">{{personBasicInfo.birthdateString}}</td>
            </tr>
            <tr>
                <th class="text-center align-middle" style="width: 15%">民族</th>
                <td class="text-left align-middle" style="width: 28%">{{personBasicInfo.nation}}</td>
                <th class="text-center align-middle" style="width: 15%">政治面貌</th>
                <td class="text-left align-middle" style="width: 28%">{{personBasicInfo.politicalOutlook}}</td>
            </tr>
            <tr>
                <th class="text-center align-middle" style="width: 15%">学历</th>
                <td class="text-left align-middle" style="width: 28%">{{personBasicInfo.education}}</td>
                <th class="text-center align-middle" style="width: 15%">学位</th>
                <td class="text-left align-middle" style="width: 28%">{{personBasicInfo.degree}}</td>
            </tr>
            <tr>
                <th class="text-center align-middle" style="width: 15%">专业</th>
                <td class="text-left align-middle" colspan="3">{{personBasicInfo.major}}</td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import userApi from "@/utils/api/user";
import url from "@/utils/api/url";
import {encryptDes, encryptDesWithKey, generatekey} from '@/utils/DES.js'

export default {
    name: "StudentBasicPictureInfoView",
    props: {
        personId: {type: String, required: true},
    },
    data: function () {
        return {
            personBasicInfo: {},
            personPictureInfo: {},
            userType:this.$store.state.userType,
        };
    },
    computed: {
        displayPictureUrl() {
            if (this.personPictureInfo.picture) {
                return url.URL_ROOT + this.personPictureInfo.picture;
            }
            else {
                return '/images/default-user.jpg';
            }
        }
    },
    mounted() {
        this.getPersonBasicInfo();
        this.getPersonPictureInfo();
    },
    methods: {
        getPersonBasicInfo() {
            let info = {personId: this.personId, userType: this.entryUserType()};
            userApi.person.basic.getStudentBasicInfo(info).then(res => {
                this.personBasicInfo = res.data;
            });
        },
        getPersonPictureInfo() {
            userApi.person.picture.getStudentPictureInfo(this.personId).then(res => {
                this.personPictureInfo = res.data;
            });
        },
        entryUserType(){
            let userType = this.userType
            let key = generatekey(16)
            let timeStamp = new Date().getTime()
            const userTypeDes = encryptDesWithKey(key, userType)
            const data = { userType: userTypeDes, timeStamp: timeStamp, key: key }
            const userTypeReal = encryptDes(JSON.stringify(data))
            return userTypeReal
        },
    }
}
</script>

<style scoped>

</style>